import { giphyBlack, giphyWhite } from '@giphy/colors'
import { SearchContext } from '@giphy/react-components'
import { useContext, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import Channels from './channels'
import SearchTags from './search-tags'
import TrendingCarousel from './trending-carousel'
import TrendingSearches from './trending-searches'
import useWindowSize from 'react-use/lib/useWindowSize'
import { desktop } from 'ui/src/css'
import { desktopHeaderWidth } from 'ui/src/components/header'

const Container = styled.div<{ $isStuck: boolean }>`
    background: ${giphyBlack};
    width: 100%;
    position: absolute;
    min-height: 100vh;
    ${(props) =>
        props.$isStuck &&
        desktop(css`
            width: calc(100% - ${desktopHeaderWidth}px);
        `)}
    ${desktop(css`
        background: ${giphyWhite};
        min-height: unset;
        border-radius: 4px;
    `)}
`

const SearchDropdown = ({ isStuck, shouldOpen }: { isStuck: boolean; shouldOpen: boolean }) => {
    const { isFocused, term, activeChannel } = useContext(SearchContext)
    const [delayedFocus, setDelayedFocus] = useState(isFocused)
    const { width } = useWindowSize()
    const isMobile = width < desktop.breakpointWidth

    useEffect(() => {
        let timeout: NodeJS.Timeout
        if (!isFocused) {
            // let a click event propagate even after blur
            timeout = setTimeout(() => setDelayedFocus(false), 100)
        } else {
            setDelayedFocus(true)
        }
        return () => clearTimeout(timeout)
    }, [isFocused])

    return delayedFocus && shouldOpen ? (
        activeChannel ? (
            <Container $isStuck={isStuck} />
        ) : (
            <Container $isStuck={isStuck}>
                {term ? (
                    <>
                        {term.indexOf('@') !== 0 && <SearchTags />}
                        <Channels />
                    </>
                ) : isMobile ? (
                    <>
                        <TrendingCarousel />
                        <TrendingSearches />
                    </>
                ) : null}
            </Container>
        )
    ) : null
}

export default SearchDropdown
